import type { ActivityBucket, GanttReport } from "../../../queries/reports";
import { ActivityChart } from "./ActivityChart";
import { DashCard } from "./DashCard";
import { GanttBars, ganttItems } from "./GanttBars";
import { formatHours } from "./format";
import styles from "./dash.module.css";

interface QueryState { loading: boolean; error: boolean; onRetry: () => void; }

interface Props {
  activity?: ActivityBucket[];
  granularity: "day" | "week";
  activityState: QueryState;
  gantt?: GanttReport;
  ganttState: QueryState;
}

export const TimelineSection = ({ activity, granularity, activityState, gantt, ganttState }: Props) => {
  const data = activity || [];
  const opened = data.reduce((n, d) => n + d.ticketsOpened, 0);
  const solved = data.reduce((n, d) => n + d.ticketsSolved, 0);
  const minutes = data.reduce((n, d) => n + d.totalMinutes, 0);
  return (
    <div className={styles.stack}>
      <DashCard
        title="Ticket activity"
        helper={`Tickets opened and solved per ${granularity} with the hours the team logged. ${opened} opened, ${solved} solved, ${formatHours(minutes)} logged in this range.`}
        loading={activityState.loading}
        error={activityState.error}
        onRetry={activityState.onRetry}
        empty={data.length === 0}
        emptyTitle="No activity in this range"
        emptyText="Pick a longer range or check back once tickets are opened."
      >
        <ActivityChart data={data} granularity={granularity} />
      </DashCard>
      <DashCard
        title="Projects and sprints timeline"
        helper="Project start to target date, and sprint start to end date. The vertical line is today."
        loading={ganttState.loading}
        error={ganttState.error}
        onRetry={ganttState.onRetry}
        empty={!gantt || ganttItems(gantt).length === 0}
        emptyTitle="Nothing scheduled"
        emptyText="Give projects a start and target date, or plan a sprint, to see them here."
      >
        {gantt && <GanttBars report={gantt} />}
      </DashCard>
    </div>
  );
};
